import { useTranslation } from "react-i18next";
import commonContent from "../../../../content/common";
import { getDisplayName } from "../../../../common/util/displayName";
import { padAff } from "../../../../common/util/affPadding";
import { showProfile } from "../../../../reducers/profile";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { CustomerBasicInfo } from "../BasicInfo/BasicInfo";
import ContactActions, { SponsorContactActions } from "../ContactActions/ContactActions";
import ProfileBannerLayout from "./ProfileBannerLayout";
import useProfileBannerData from "./useProfileBannerData";

type Props = { pushToHistory?: (affAbo: string) => void };

const CustomerProfileBanner = ({ pushToHistory }: Props) => {
  const { aff, abo, data, isFetching, isError, refetch, tags } = useProfileBannerData();
  const { aboInfo, partyInfo } = data ?? {};
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["downlineProfile", "common"]);
  const loggedInUser = useAppSelector((s) => s.boot.user);
  const sponsor = aboInfo?.sponsor;
  const sponsorAff = padAff(sponsor?.affNo);
  const sponsorAbo = sponsor?.aboNo ?? "";
  const hasSponsor = Boolean(sponsor?.isValid && sponsorAff && sponsorAbo);
  const isOwnCustomer = Boolean(
    hasSponsor &&
    loggedInUser.aff &&
    loggedInUser.abo &&
    sponsorAff === padAff(loggedInUser.aff) &&
    sponsorAbo === loggedInUser.abo,
  );
  const showSponsor = !isFetching && hasSponsor && !isOwnCustomer;
  const sponsorIsConfidential = Boolean(sponsor?.privacyFlag);
  const sponsorName = sponsorIsConfidential
    ? t("confidentialUser", commonContent.confidentialUser, { ns: "common" })
    : getDisplayName(sponsor?.displayName || sponsor?.name || sponsor?.nameLocal, t);
  const isKoreaMarket = aboInfo?.countryCode?.toUpperCase() === "KR";
  return (
    <ProfileBannerLayout
      customer
      aff={aff}
      abo={abo}
      imageRefUrl={aboInfo?.imageRefUrl}
      pushToHistory={pushToHistory}
      isFetching={isFetching}
      isError={isError}
      refetch={refetch}
      basicInfo={
        <CustomerBasicInfo aboInfo={aboInfo} tags={tags} isLoading={isFetching} isConfidential={aboInfo?.privacyFlag} />
      }
      contacts={
        showSponsor ? (
          <SponsorContactActions
            name={sponsorName}
            onClick={() => dispatch(showProfile(`${sponsorAff}-${sponsorAbo}`))}
            phone={sponsor?.phone?.displayNumber}
            email={sponsor?.email}
            isConfidential={sponsorIsConfidential}
            isKoreaMarket={isKoreaMarket}
          />
        ) : (
          <ContactActions
            partyInfo={!isFetching && isOwnCustomer ? partyInfo : undefined}
            isLoading={isFetching}
            isConfidential={aboInfo?.privacyFlag}
            isKoreaMarket={isKoreaMarket}
          />
        )
      }
    />
  );
};

export default CustomerProfileBanner;
